import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		headsearchlist: [{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "所属期",
				prop: "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "发票代码",
				prop: "fapdm",
				type: "input"
			},
			{
				label: "发票号码",
				prop: "faphm",
				type: "input"
			},

			{
				label: "开票日期",
				prop: "kaiprq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "发票类型",
				prop: "faplx",
				type: "select",
				selectval: comMapping.$fplx,
			},
			{
				label: "含税金额合计",
				prop: "hansjehj",
				type: "input"
			},
			{
				label: "未税金额合计",
				prop: "weisjehj",
				type: "input"
			}, {
				label: "税额合计",
				prop: "shuiehj",
				type: "input"
			},

			{
				label: "记账标志",
				prop: "jizbz",
				type: "select",
				selectval: comMapping.$jizbz
			}, {
				label: "抵扣标志",
				prop: "dikbz",
				type: "select",
				selectval: comMapping.$Dikbz
			}, {
				label: "抵扣税额",
				prop: "dikse",
				type: "input"
			}, {
				label: "批次号",
				prop: "pich",
				type: "input"
			},

		],
		zzssearchlist: [{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "所属期",
				prop: "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "发票代码",
				prop: "fapdm",
				type: "input"
			},
			{
				label: "发票号码",
				prop: "faphm",
				type: "input"
			},
			{
				label: "开票日期",
				prop: "kaiprq",
				type: "datemonth",
				valueformat: 'yyyyMMdd'
			},
			{
				label: "发票类型",
				prop: "faplx",
				type: "select",
				selectval: comMapping.$fplx,
			},
			{
				label: "未税金额合计",
				prop: "weisjehj",
				type: "input"
			},
			{
				label: "税额合计",
				prop: "shuiehj",
				type: "input"
			},
			{
				label: "含税金额合计",
				prop: "hansjehj",
				type: "input"
			},
			{
				label: "购方名称",
				prop: "goufmc",
				type: "input"
			},
			{
				label: "购方税号",
				prop: "goufsbh",
				type: "input"
			},
			{
				label: "购方地址、电话",
				prop: "goufdzdh",
				type: "input"
			},
			{
				label: "购方开户行及账号",
				prop: "goufkhhjzh",
				type: "input"
			},
			{
				label: "销方名称",
				prop: "xiaofmc",
				type: "input"
			},
			{
				label: "销方税号",
				prop: "xiaofsbh",
				type: "input"
			},
			{
				label: "销方地址、电话",
				prop: "xiaofdzdh",
				type: "input"
			},
			{
				label: "销方开户行及账号",
				prop: "xiaofkhhjzh",
				type: "input"
			},
			{
				label: "备注",
				prop: "beiz",
				type: "input"
			},
			{
				label: "开票人",
				prop: "kaipr",
				type: "input"
			},
			{
				label: "复核人 ",
				prop: "fuhr",
				type: "input"
			},
			{
				label: "收款人",
				prop: "shoukr",
				type: "input"
			},
			{
				label: "记账标志",
				prop: "jizbz",
				type: "select",
				selectval: comMapping.$jizbz
			},
			{
				label: "认证标志",
				prop: "renzbz",
				type: "select",
				selectval: comMapping.$Renzbz
			},
			{
				label: "抵扣标志",
				prop: "dikbz",
				type: "select",
				selectval: comMapping.$Dikbz
			},
			{
				label: "抵扣税额",
				prop: "dikse",
				type: "input"
			},
			{
				label: "校验码",
				prop: "jiaoym",
				type: "input"
			},
			{
				label: "机器编号",
				prop: "jiqbh",
				type: "input"
			},
			{
				label: "特殊标志",
				prop: "biaoz",
				type: "select",
				selectval: comMapping.$biaoz
			}
		],
		xcdsearchlist: [

			{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "所属期",
				prop: "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "电子客票号码",
				prop: "number",
				type: "input"
			},
			{
				label: "乘机人姓名",
				prop: "userName",
				type: "input"
			}, {
				label: "身份证号",
				prop: "userId",
				type: "input"
			}, {
				label: "填开日期",
				prop: "tiankrq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			}, {
				label: "填开单位",
				prop: "tiankdw",
				type: "input"
			}, {
				label: "票价",
				prop: "piaoj",
				type: "input"
			}, {
				label: "税费",
				prop: "shuif",
				type: "input"
			}, {
				label: "总额",
				prop: "zonge",
				type: "input"
			}, {
				label: "发票消费类型",
				prop: "fapxflx",
				type: "input"
			}, {
				label: "抵扣标志",
				prop: "dikbz",
				type: "select",
				selectval: comMapping.$Dikbz
			}, {
				label: "批次号",
				prop: "pich",
				type: "input"
			},
		],
		hcpsearchlist: [{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "所属期",
				prop: "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "号码",
				prop: "haom",
				type: "input"
			},
			{
				label: "乘车日期",
				prop: "date",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "乘车时间",
				prop: "time",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "乘车人姓名",
				prop: "name",
				type: "input"
			},
			{
				label: "座位类型",
				prop: "zuowlx",
				type: "input"
			},
			{
				label: "总金额",
				prop: "total",
				type: "input"
			},
			{
				label: "发票消费类型",
				prop: "fapxflx",
				type: "input"
			},
			{
				label: "抵扣标志",
				prop: "dikbz",
				type: "select",
				selectval: comMapping.$Dikbz
			},
			{
				label: "批次号",
				prop: "pich",
				type: "input"
			},

		],
		glfsearchlist: [{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "所属期",
				prop: "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "发票代码",
				prop: "fapdm",
				type: "input"
			},
			{
				label: "发票号码",
				prop: "faphm",
				type: "input"
			},
			{
				label: "日期",
				prop: "date",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "时间",
				prop: "time",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "入口",
				prop: "entrance",
				type: "input"
			},
			{
				label: "出口",
				prop: "chuk",
				type: "input"
			},
			{
				label: "总金额",
				prop: "total",
				type: "input"
			},
			{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "发票消费类型",
				prop: "fapxflx",
				type: "input"
			},
			{
				label: "高速标志",
				prop: "gaosbz",
				type: "select",
				selectval: comMapping.$gaosbz,
			}, {
				label: "抵扣标志",
				prop: "dikbz",
				type: "select",
				selectval: comMapping.$Dikbz
			},
			{
				label: "批次号",
				prop: "pich",
				type: "input"
			},
		],
		czcsearchlist: [{
				label: "公司代码",
				prop: "companyCode",
				type: "input"
			},
			{
				label: "所属期",
				prop: "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "发票代码",
				prop: "fapdm",
				type: "input"
			},
			{
				label: "发票号码",
				prop: "faphm",
				type: "input"
			},
			{
				label: "乘车日期",
				prop: "date",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				label: "里程",
				prop: "lc",
				type: "input"
			},
			{
				label: "总金额",
				prop: "total",
				type: "input"
			},
			{
				label: "发票所在地",
				prop: "fapszd",
				type: "input"
			},
			{
				label: "省",
				prop: "province",
				type: "input"
			},
			{
				label: "市",
				prop: "city",
				type: "input"
			},
			{
				label: "抵扣标志",
				prop: "dikbz",
				type: "select",
				selectval: comMapping.$Dikbz
			},
			{
				label: "批次号",
				prop: "pich",
				type: "input"
			},
		],
		qcpsearchlist: [{
			label: "公司代码",
			prop: "companyCode",
			type: "input"
		}, {
			label: "所属期",
			prop: "suosq",
			type: "datemonth",
			valueformat: 'yyyyMM'
		}, {
			label: "发票代码",
			prop: "fapdm",
			type: "input"
		}, {
			label: "发票号码",
			prop: "faphm",
			type: "input"
		}, {
			label: "日期",
			prop: "date",
			type: "datemonth",
			valueformat: 'yyyyMM'
		}, {
			label: "时间",
			prop: "time",
			type: "datemonth",
			valueformat: 'yyyyMM'
		}, {
			label: "出发车站",
			prop: "chufcz",
			type: "input"
		}, {
			label: "到达车站",
			prop: "dadcz",
			type: "input"
		}, {
			label: "总金额",
			prop: "total",
			type: "input"
		}, {
			label: "姓名",
			prop: "name",
			type: "input"
		}, {
			label: "发票消费类型",
			prop: "fapxflx",
			type: "input"
		}, {
			label: "身份证号",
			prop: "userId",
			type: "input"
		}, {
			label: "抵扣标志",
			prop: "dikbz",
			type: "select",
			selectval: comMapping.$Dikbz
		}, {
			label: "批次号",
			prop: "pich",
			type: "input"
		}, ],
		defqsearchlist: [{
			label: "公司代码",
			prop: "companyCode",
			type: "input"
		}, {
			label: "所属期",
			prop: "suosq",
			type: "datemonth",
			valueformat: 'yyyyMM'
		}, {
			label: "发票代码",
			prop: "fapdm",
			type: "input"
		}, {
			label: "发票号码",
			prop: "faphm",
			type: "input"
		}, {
			label: "总金额",
			prop: "total",
			type: "input"
		}, {
			label: "发票消费类型",
			prop: "fapxflx",
			type: "input"
		}, {
			label: "省",
			prop: "province",
			type: "input"
		}, {
			label: "市",
			prop: "city",
			type: "input"
		}, {
			label: "抵扣标志",
			prop: "dikbz",
			type: "select",
			selectval: comMapping.$Dikbz
		}, {
			label: "批次号",
			prop: "pich",
			type: "input"
		}, ],
		cpsearchlist: [{
			label: "公司代码",
			prop: "companyCode",
			type: "input"
		}, {
			label: "所属期",
			prop: "suosq",
			type: "datemonth",
			valueformat: 'yyyyMM'
		}, {
			label: "发票代码",
			prop: "fapdm",
			type: "input"
		}, {
			label: "发票号码",
			prop: "faphm",
			type: "input"
		}, {
			label: "总金额",
			prop: "total",
			type: "input"
		}, {
			label: "发票消费类型",
			prop: "fapxflx",
			type: "input"
		}, {
			label: "省",
			prop: "province",
			type: "input"
		}, {
			label: "市",
			prop: "city",
			type: "input"
		}, {
			label: "抵扣标志",
			prop: "dikbz",
			type: "select",
			selectval: comMapping.$Dikbz
		}, {
			label: "批次号",
			prop: "pich",
			type: "input"
		}, ],
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 100,
				custom:true,
			},
			{
				title: "所属期",
				prop: "suosq",
				width: 100,
				custom:true,

			},
			{
				title: "发票代码",
				prop: "fapdm",
				custom:true,
				width: 100
			},
			{
				title: "发票号码",
				prop: "faphm",
				width: 100,
				custom:true,

			},

			{
				title: "开票日期",
				prop: "kaiprq",
				custom:true,
				width: 100
			},

			
			{
				title: "开票类型",
				prop: "faplx",
				custom: true,
				width: 100
			},
			{
				title: "含税金额合计",
				prop: "hansjehj",
				custom:true,
				width: 150
			},
			{
				title: "未税金额合计",
				prop: "weisjehj",
				custom:true,
				width: 150
			}, {
				title: "税额合计",
				prop: "shuiehj",
				custom:true,
				width: 100
			},

			{
				title: "记账标志",
				prop: "jizbz",
				custom: true,
				width: 100
			}, {
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			}, {
				title: "抵扣税额",
				prop: "dikse",
				custom: true,

				width: 100
			}, {
				title: "批次号",
				prop: "pich",
				custom: true,

				width: 100
			},

		],
		zzsData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80,
				custom:true,

			},
			{
				title: "所属期",
				custom:true,
				prop: "suosq",
				width: 80
			},
			{
				title: "发票代码",
				custom:true,
				prop: "fapdm",
				width: 100
			},
			{
				title: "发票号码",
				custom:true,
				prop: "faphm",
				width: 80
			},
			{
				title: "开票日期",
				custom:true,
				prop: "kaiprq",
				width: 80
			},
			{
				title: "发票类型",
				prop: "faplx",
				custom: true,
				width: 80
			},
			{
				title: "未税金额合计",
				prop: "weisjehj",
				width: 110,
				AmountFormat: true,
				custom:true,
				

			},
			{
				title: "税额合计",
				prop: "shuiehj",
				custom:true,
				width: 80,
				AmountFormat: true,
			},
			{
				title: "含税金额合计",
				prop: "hansjehj",
				custom:true,
				width: 110,
				AmountFormat: true,
			},
			{
				title: "购方名称",
				prop: "goufmc",
				custom:true,
				width: 160,
			},
			{
				title: "购方税号",
				prop: "goufsbh",
				custom:true,
				width: 160,
			},
			{
				title: "购方地址、电话",
				prop: "goufdzdh",
				custom:true,
				width: 160,
			},
			{
				title: "购方开户行及账号",
				prop: "goufkhhjzh",
				custom:true,
				width: 160,
			},
			{
				title: "销方名称",
				prop: "xiaofmc",
				custom:true,
				width: 160,
			},
			{
				title: "销方税号",
				prop: "xiaofsbh",
				custom:true,
				width: 160,
			},
			{
				title: "销方地址、电话",
				prop: "xiaofdzdh",
				custom:true,
				width: 160,
				

			},
			{
				title: "销方开户行及账号",
				prop: "xiaofkhhjzh",
				width: 160,
				custom:true,
				

			},
			{
				title: "备注",
				prop: "beiz",
				width: 160,
				custom:true,
				

			},
			{
				title: "开票人",
				prop: "kaipr",
				custom:true,
				width: 80
			},
			{
				title: "复核人 ",
				prop: "fuhr",
				custom:true,
				width: 80
			},
			{
				title: "收款人",
				prop: "shoukr",
				custom:true,
				width: 80
			},
			{
				title: "记账标志",
				prop: "jizbz",
				custom: true,
				width: 100
			},
			{
				title: "认证标志",
				prop: "renzbz",
				custom: true,
				width: 100
			},
			{
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			},
			{
				title: "抵扣税额",
				prop: "dikse",
				width: 80,
				AmountFormat: true,
				custom:true,
				
			},
			{
				title: "校验码",
				prop: "jiaoym",
				width: 160,
				custom:true,
				
			},
			{
				title: "机器编号",
				prop: "jiqbh",
				width: 160,
				custom:true,
				
			},
			{
				title: "特殊标志",
				prop: "biaoz",
				custom: true,
				width: 100
			}
		],
		xcdData: [

			{
				title: "公司代码",
				prop: "companyCode",
				custom: true,
				width: 80
			},
			{
				title: "所属期",
				prop: "suosq",
				custom: true,
				width: 80
			},{
				title: "电子客票号码",
				prop: "number",
				custom: true,
				width: 120
			}, {
				title: "乘机人姓名",
				prop: "userName",
				custom: true,
				width: 95
			}, {
				title: "身份证号",
				prop: "userId",
				custom: true,
				width: 160,
				
			}, {
				title: "填开日期",
				prop: "tiankrq",
				custom: true,
				width: 80
			}, {
				title: "填开单位",
				prop: "tiankdw",
				custom: true,
				width: 160,
				
			}, {
				title: "票价",
				prop: "piaoj",
				width: 80,
				AmountFormat: true,
				custom: true,
				
			}, {
				title: "税费",
				prop: "shuif",
				custom: true,
				width: 80,
				AmountFormat: true,
				
			}, {
				title: "总额",
				prop: "zonge",
				width: 80,
				AmountFormat: true,
				custom: true,
				
			}, {
				title: "发票消费类型",
				prop: "fapxflx",
				custom: true,
				width: 110
			}, {
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			}, {
				title: "批次号",
				prop: "pich",
				custom: true,
				width: 160,
				
			},
		],
		hcpData: [{
				title: "公司代码",
				prop: "companyCode",
				custom: true,
				width: 80
			},
			{
				title: "所属期",
				custom: true,
				prop: "suosq",
				width: 80
			},
			{
				title: "号码",
				prop: "haom",
				custom: true,
				width: 80
			},
			{
				title: "乘车日期",
				prop: "date",
				custom: true,
				width: 80
			},
			{
				title: "乘车时间",
				prop: "time",
				custom: true,
				width: 80
			},
			{
				title: "乘车人姓名",
				prop: "name",
				custom: true,
				width: 95
			},
			{
				title: "座位类型",
				prop: "zuowlx",
				custom: true,
				width: 80
			},
			{
				title: "总金额",
				prop: "total",
				width: 80,
				AmountFormat: true,
				custom: true,
				
			},
			{
				title: "发票消费类型",
				prop: "fapxflx",
				custom: true,
				width: 110
			},
			{
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			},
			{
				title: "批次号",
				prop: "pich",
				width: 160,
				custom: true,
				
			},

		],
		glfData: [{
				title: "公司代码",
				prop: "companyCode",
				custom: true,
				width: 80
			},
			{
				title: "所属期",
				prop: "suosq",
				custom: true,
				width: 80
			},
			{
				title: "发票代码",
				prop: "fapdm",
				custom: true,
				width: 100
			},
			{
				title: "发票号码",
				prop: "faphm",
				custom: true,
				width: 80
			},
			{
				title: "日期",
				prop: "date",
				custom: true,
				width: 80
			},
			{
				title: "时间",
				prop: "time",
				custom: true,
				width: 80
			},
			{
				title: "入口",
				prop: "entrance",
				custom: true,
				width: 110
			},
			{
				title: "出口",
				prop: "chuk",
				custom: true,
				width: 110
			},
			{
				title: "总金额",
				prop: "total",
				width: 80,
				AmountFormat: true,
				custom: true,
				
			},
			{
				title: "公司代码",
				prop: "companyCode",
				custom: true,
				width: 80
			},
			{
				title: "发票消费类型",
				prop: "fapxflx",
				custom: true,
				width: 110
			},
			{
				title: "高速标志",
				prop: "gaosbz",
				custom: true,
				width: 100
			}, {
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			},
			{
				title: "批次号",
				prop: "pich",
				custom: true,
				width: 160,
				
			},
		],
		czcData: [{
				title: "公司代码",
				prop: "companyCode",
				custom: true,
				width: 80
			},
			{
				title: "所属期",
				prop: "suosq",
				custom: true,
				width: 80
			},
			{
				title: "发票代码",
				custom: true,
				prop: "fapdm",
				width: 100
			},
			{
				title: "发票号码",
				prop: "faphm",
				custom: true,
				width: 80
			},
			{
				title: "乘车日期",
				prop: "date",
				custom: true,
				width: 80
			},
			{
				title: "里程",
				prop: "lc",
				custom: true,
				width: 80
			},
			{
				title: "总金额",
				prop: "total",
				custom: true,
				width: 80,
				AmountFormat: true,
				
			},
			{
				title: "发票所在地",
				custom: true,
				prop: "fapszd",
				width: 90
			},
			{
				custom: true,
				title: "省",
				prop: "province",
				width: 80
			},
			{
				title: "市",
				custom: true,
				prop: "city",
				width: 80
			},
			{
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			},
			{
				title: "批次号",
				custom: true,
				prop: "pich",
				width: 160,
				
			},
		],
		qcpData: [{
			title: "公司代码",
			custom: true,
			prop: "companyCode",
			width: 80
		}, {
			custom: true,
			title: "所属期",
			prop: "suosq",
			width: 80
		}, {
			custom: true,
			title: "发票代码",
			prop: "fapdm",
			width: 100
		}, {
			title: "发票号码",
			custom: true,
			prop: "faphm",
			width: 80
		}, {
			custom: true,
			title: "日期",
			prop: "date",
			width: 80
		}, {
			custom: true,
			title: "时间",
			prop: "time",
			width: 80
		}, {
			title: "出发车站",
			custom: true,
			prop: "chufcz",
			width: 80
		}, {
			title: "到达车站",
			custom: true,
			prop: "dadcz",
			width: 80
		}, {
			title: "总金额",
			prop: "total",
			width: 80,
			AmountFormat: true,
			custom: true,
			
		}, {
			title: "姓名",
			prop: "name",
			custom: true,
			width: 80
		}, {
			title: "发票消费类型",
			custom: true,
			prop: "fapxflx",
			width: 110
		}, {
			title: "身份证号",
			custom: true,
			prop: "userId",
			width: 160,
			
		}, {
			title: "抵扣标志",
			prop: "dikbz",
			custom: true,
			width: 100
		}, {
			title: "批次号",
			custom: true,
			prop: "pich",
			width: 160,
			
		}, ],
		defqData: [{
			title: "公司代码",
			custom: true,
			prop: "companyCode",
			width: 80
		}, {
			custom: true,
			title: "所属期",
			prop: "suosq",
			width: 80
		}, {
			title: "发票代码",
			custom: true,
			prop: "fapdm",
			width: 100
		}, {
			title: "发票号码",
			custom: true,
			prop: "faphm",
			width: 80
		}, {
			title: "总金额",
			prop: "total",
			width: 80,
			AmountFormat: true,
			custom: true,
			
		}, {
			title: "发票消费类型",
			custom: true,
			prop: "fapxflx",
			width: 110
		}, {
			title: "省",
			prop: "province",
			custom: true,
			width: 80
		}, {
			title: "市",
			custom: true,
			prop: "city",
			width: 80
		}, {
			title: "抵扣标志",
			prop: "dikbz",
			custom: true,
			width: 100
		}, {
			title: "批次号",
			prop: "pich",
			custom: true,
			width: 160,
			
		}, ],
		cpData: [{
			title: "公司代码",
			custom: true,
			prop: "companyCode",
			width: 80
		}, {
			title: "所属期",
			custom: true,
			prop: "suosq",
			width: 80
		}, {
			title: "发票代码",
			prop: "fapdm",
			custom: true,
			width: 100
		}, {
			custom: true,
			title: "发票号码",
			prop: "faphm",
			width: 80
		}, {
			title: "总金额",
			prop: "total",
			custom: true,
			width: 80,
			AmountFormat: true,
			
		}, {
			title: "发票消费类型",
			custom: true,
			prop: "fapxflx",
			width: 110
		}, {
			custom: true,
			title: "省",
			prop: "province",
			width: 80
		}, {
			custom: true,
			title: "市",
			prop: "city",
			width: 80
		}, {
			title: "抵扣标志",
			prop: "dikbz",
			custom: true,
			width: 100
		}, {
			custom: true,
			title: "批次号",
			prop: "pich",
			width: 160,
			
		}, ],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		searchdata: {
			// companyCode: "",
			// shenbq: "",
			// fapdm: "",
			// other: "",
			// faphm: "",
			// kaiprq: "",
			// faplx: "",
			// hansje: "",
			// suihuig: '',
			// Bookkeeping: "",
			// Deduction: "",
			// amount: "",
			// Batch: "",
		},
		bott: [{
			name: '增值税发票',
			value: 0,
		}, {
			name: '航运行程单',
			value: 1,
		}, {
			name: '过路费',
			value: 2,
		}, {
			name: '火车票',
			value: 3,
		}, {
			name: '出租车票',
			value: 4,
		}, {
			name: '汽车票',
			value: 5,
		}, {
			name: '定额发票',
			value: 6,
		}, {
			name: '船票',
			value: 7,
		}],
	}
	return obj
}
